const setA2PComplianceStatus = async function ({ commit}, payload) {
  const { currentStatus } = payload
  commit('setA2PComplianceStatus', currentStatus.value)
  return
}

export default setA2PComplianceStatus
